import { render, staticRenderFns } from "./SharePayments.vue?vue&type=template&id=305005b6&lang=pug"
import script from "./SharePayments.vue?vue&type=script&lang=js"
export * from "./SharePayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports